// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"633":"d648f00f2c52549f","896":"1992e0826ef94a17"}[chunkId] + ".js";
};